import { c as _c } from "react/compiler-runtime";
import { isVaultDataDecrypted, isVaultDataEmpty, isVaultDataEncrypted } from '@onefootprint/core';
import type { DataIdentifier, Entity } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import useEntityVault from '@/entities/hooks/use-entity-vault';
import useAutoDecryptControls from '@/entity/hooks/use-auto-decrypt-controls';
import useDecryptControls from '@/entity/hooks/use-decrypt-controls';
import isDiDecryptable from '@/utils/is-di-decryptable';
const useField = entity => {
  const $0 = _c(19);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "di"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($0[1] !== entity.data || $0[2] !== entity.id) {
    t1 = {
      entityAttributes: entity.data,
      entityId: entity.id
    };
    $0[1] = entity.data;
    $0[2] = entity.id;
    $0[3] = t1;
  } else {
    t1 = $0[3];
  }
  const entityVaultQuery = useEntityVault(t1);
  const decryptControls = useDecryptControls();
  const autoDecryptControls = useAutoDecryptControls(entity.kind);
  const showCheckbox = decryptControls.step === "selecting-fields" || decryptControls.step === "selecting-reason";
  let t2;
  if ($0[4] !== entity) {
    t2 = di => isDiDecryptable(entity, di);
    $0[4] = entity;
    $0[5] = t2;
  } else {
    t2 = $0[5];
  }
  const canDecryptField = t2;
  let t3;
  if ($0[6] !== canDecryptField || $0[7] !== entityVaultQuery.data?.vault) {
    t3 = di_0 => {
      const value = entityVaultQuery.data?.vault[di_0];
      return canDecryptField(di_0) && isVaultDataEncrypted(value);
    };
    $0[6] = canDecryptField;
    $0[7] = entityVaultQuery.data?.vault;
    $0[8] = t3;
  } else {
    t3 = $0[8];
  }
  const canSelect = t3;
  let t4;
  if ($0[9] !== autoDecryptControls || $0[10] !== canDecryptField || $0[11] !== canSelect || $0[12] !== decryptControls || $0[13] !== entity.id || $0[14] !== entityVaultQuery.data?.transforms || $0[15] !== entityVaultQuery.data?.vault || $0[16] !== showCheckbox || $0[17] !== t) {
    t4 = di_1 => {
      const value_0 = entityVaultQuery.data?.vault[di_1];
      const transforms = entityVaultQuery.data?.transforms[di_1];
      return {
        isAutoDecrypting: autoDecryptControls.isEntityAutoDecrypting(entity.id) && decryptControls.isDecrypting([di_1]),
        canDecrypt: canDecryptField(di_1),
        canSelect: canSelect(di_1),
        disabled: !canSelect(di_1),
        label: t($ => $[di_1]),
        name: di_1,
        showCheckbox,
        value: value_0,
        transforms,
        isDecrypted: isVaultDataDecrypted(value_0),
        isEmpty: isVaultDataEmpty(value_0)
      };
    };
    $0[9] = autoDecryptControls;
    $0[10] = canDecryptField;
    $0[11] = canSelect;
    $0[12] = decryptControls;
    $0[13] = entity.id;
    $0[14] = entityVaultQuery.data?.transforms;
    $0[15] = entityVaultQuery.data?.vault;
    $0[16] = showCheckbox;
    $0[17] = t;
    $0[18] = t4;
  } else {
    t4 = $0[18];
  }
  const getProps = t4;
  return getProps;
};
export default useField;